import { jsx } from 'react/jsx-runtime';
import { Typography, ErrorBoundary } from '@vp/swan';
import { forwardRef } from 'react';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { formatQuantity } from './ep-pricing-esm-utils-formatter.util.js';
import styles from './ep-pricing-esm-components-units-count-units-count.module.scss.js';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';

const UnitsCountInternal = forwardRef((props, ref) => {
  const { className, quantity, locale, ...rest } = props;
  const classNames = clsx(className, styles.unitsCount);
  const { t } = useLocalization(locale);
  const formattedQuantity = formatQuantity(locale, quantity);
  const translationKey = quantity === 1 ? "unitCount" : "unitsCount";
  return /* @__PURE__ */ jsx(Typography, { as: "span", ref, className: classNames, fontSkin: "body-small", textColor: "subtle", ...rest, children: t(translationKey, { unitsCount: formattedQuantity }) });
});
forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    ErrorBoundary,
    {
      fallback: /* @__PURE__ */ jsx(Typography, { as: "span", fontSkin: "body-small", textColor: "subtle", children: props.placeholdertext }),
      children: /* @__PURE__ */ jsx(UnitsCountInternal, { ...props, ref })
    }
  );
});

export { UnitsCountInternal };
//# sourceMappingURL=ep-pricing-esm-components-units-count-units-count.component.js.map
